import AdminActivities from './AdminActivities'

export default AdminActivities
